// 音頻快取工具
class AudioCache {
  private cache = new Map<string, { data: ArrayBuffer; ts: number }>()
  private maxSize = 100 // 最多快取 100 個音頻（從 50 增加到 100）
  private ttlMs = 600_000 // 10 分鐘快取 TTL（從 60 秒增加到 600 秒）

  private generateKey(text: string, voiceId: number, level?: string): string {
    // 如果沒有 level，保持向後兼容（使用舊的鍵格式）
    return level ? `${text}_${voiceId}_${level}` : `${text}_${voiceId}`
  }

  get(text: string, voiceId: number, level?: string): ArrayBuffer | null {
    const key = this.generateKey(text, voiceId, level)
    const hit = this.cache.get(key)
    if (!hit) return null
    if (Date.now() - hit.ts > this.ttlMs) {
      this.cache.delete(key)
      return null
    }
    return hit.data
  }

  set(text: string, voiceId: number, audio: ArrayBuffer, level?: string): void {
    const key = this.generateKey(text, voiceId, level)
    
    // 如果快取已滿，移除最舊的項目
    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value
      if (firstKey !== undefined) {
        this.cache.delete(firstKey)
      }
    }
    
    this.cache.set(key, { data: audio, ts: Date.now() })
  }

  clear(): void {
    this.cache.clear()
  }

  size(): number {
    return this.cache.size
  }
}

export const audioCache = new AudioCache()

// 快取常用音頻
export const preloadCommonAudio = async () => {
  const commonTexts = [
    'こんにちは',
    'ありがとう',
    'すみません',
    'はい',
    'いいえ'
  ]
  
  const commonVoices = [13, 8, 11, 2]
  
  for (const text of commonTexts) {
    for (const voiceId of commonVoices) {
      try {
        const response = await fetch('/api/voicevox/audio_query', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ text, speaker: voiceId })
        })
        
        if (response.ok) {
          const queryData = await response.json()
          const audioResponse = await fetch(`/api/voicevox/synthesis?speaker=${voiceId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(queryData)
          })
          
          if (audioResponse.ok) {
            const audio = await audioResponse.arrayBuffer()
            audioCache.set(text, voiceId, audio)
          }
        }
      } catch (error) {
        // console.log('預載音頻失敗:', text, voiceId, error)
      }
    }
  }
}
